
(() => {
  if (window.__hoMobileShoppingNative20261028) return;
  window.__hoMobileShoppingNative20261028 = true;
  const phone = window.matchMedia('(max-width: 749px)');

  // Keep quick shop available, but use the full product page for Choose options.
  document.addEventListener('click', event => {
    if (!phone.matches || !/\/collections\/all\/?$/.test(location.pathname)) return;
    const button = event.target instanceof Element && event.target.closest('button[data-quickshop-slim]');
    if (!button || button.disabled) return;
    const card = button.closest('[data-product-item]');
    const link = card && card.querySelector('a[data-product-page-link]');
    if (!link) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || !destination.pathname.includes('/products/')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(destination.href);
  }, true);

  // Reuse the original buying form and pricing table, as on pleached products.
  const records = new Map();
  function apply(record) {
    const {picker, native, section, account} = record;
    if (!picker.isConnected || !native.isConnected) return;
    if (phone.matches) {
      record.active = true;
      if (!picker.hidden) picker.hidden = true;
      if (native.hidden) native.hidden = false;
      if (!section.classList.contains('ho-vp-dropdown-active')) section.classList.add('ho-vp-dropdown-active');
      if (!section.hasAttribute('data-ho-native-phone')) section.setAttribute('data-ho-native-phone', '');
      if (account && account.parentElement !== native) native.insertBefore(account, native.firstChild);
    } else if (record.active) {
      record.active = false;
      picker.hidden = record.pickerHidden;
      native.hidden = record.nativeHidden;
      section.classList.toggle('ho-vp-dropdown-active', record.dropdownActive);
      section.removeAttribute('data-ho-native-phone');
      if (account && record.accountParent.isConnected) {
        record.accountParent.insertBefore(account, record.accountNext?.parentNode === record.accountParent ? record.accountNext : null);
      }
    }
  }
  function setup() {
    document.querySelectorAll('ho-variant-picker[data-native-form-id]').forEach(picker => {
      if (records.has(picker)) { apply(records.get(picker)); return; }
      const native = document.getElementById(picker.dataset.nativeFormId);
      const section = picker.closest('[id^="shopify-section-"]');
      if (!native || !section || !native.querySelector('form')) return;
      const account = picker.querySelector('.ho-account-pricing');
      const record = {picker, native, section, account, active: false,
        pickerHidden: picker.hidden, nativeHidden: native.hidden,
        dropdownActive: section.classList.contains('ho-vp-dropdown-active'),
        accountParent: account?.parentNode, accountNext: account?.nextSibling};
      records.set(picker, record);
      // The theme initializes the visual picker after DOMContentLoaded.
      // Reapply only if that initialization changes the native form or layout.
      const observer = new MutationObserver(() => { if (phone.matches) apply(record); });
      observer.observe(native, {attributes: true, attributeFilter: ['hidden']});
      observer.observe(section, {attributes: true, attributeFilter: ['class']});
      record.observer = observer;
      apply(record);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once: true});
  else setup();
  phone.addEventListener('change', () => records.forEach(apply));
  document.addEventListener('shopify:section:load', setup);
})();


;

(() => {
  if (window.__hoStyleScroll20261028) return;
  window.__hoStyleScroll20261028 = true;
  const phone = matchMedia('(max-width: 749px)');
  function showSelectedStyle() {
    if (!phone.matches) return;
    document.querySelectorAll('[data-ho-hide-unfiltered-styles=true] .ho-type-filter__styles:not([hidden]) .ho-type-filter__style-choices').forEach(strip => {
      const selected = strip.querySelector('[aria-current="true"]');
      if (!selected || strip.scrollWidth <= strip.clientWidth) return;
      const item = selected.getBoundingClientRect();
      const bounds = strip.getBoundingClientRect();
      strip.scrollTo({left: strip.scrollLeft + item.left - bounds.left - (strip.clientWidth - item.width) / 2, behavior: 'auto'});
    });
  }
  const queue = () => requestAnimationFrame(showSelectedStyle);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue, {once: true});
  else queue();
  phone.addEventListener('change', queue);
  document.addEventListener('shopify:section:load', queue);
})();


;

(() => {
  if (window.__hoStyleScrollControls20261028) return;
  window.__hoStyleScrollControls20261028 = true;

  const phone = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '[data-ho-hide-unfiltered-styles="true"] .ho-type-filter__styles:not([hidden]) .ho-type-filter__style-choices';
  const states = new Map();
  let frame = 0;
  let sequence = 0;
  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(queue) : null;

  function queue() {
    if (!frame) frame = requestAnimationFrame(refresh);
  }

  function makeButton(label, direction) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ho-style-scroll-controls__button';
    button.setAttribute('aria-label', label);
    button.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="' +
      (direction < 0 ? 'M10 3 5 8l5 5' : 'm6 3 5 5-5 5') + '"/></svg>';
    return button;
  }

  function create(strip) {
    if (!strip.id) {
      do { sequence += 1; strip.id = 'ho-phone-style-strip-' + sequence; }
      while (document.querySelectorAll('[id="' + strip.id + '"]').length > 1);
    }
    const sibling = strip.nextElementSibling;
    if (sibling?.classList.contains('ho-style-scroll-controls')) sibling.remove();

    const controls = document.createElement('div');
    controls.className = 'ho-style-scroll-controls';
    controls.hidden = true;
    const previous = makeButton('Previous styles', -1);
    const next = makeButton('Next styles', 1);
    previous.setAttribute('aria-controls', strip.id);
    next.setAttribute('aria-controls', strip.id);

    const track = document.createElement('div');
    track.className = 'ho-style-scroll-controls__track';
    track.setAttribute('aria-hidden', 'true');
    const indicator = document.createElement('span');
    indicator.className = 'ho-style-scroll-controls__indicator';
    track.append(indicator);
    controls.append(previous, track, next);
    strip.insertAdjacentElement('afterend', controls);

    const move = direction => {
      const rtl = getComputedStyle(strip).direction === 'rtl';
      const distance = Math.max(80, strip.clientWidth * .8);
      strip.scrollBy({
        left: direction * distance * (rtl ? -1 : 1),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    strip.addEventListener('scroll', queue, {passive: true});
    resizeObserver?.observe(strip);

    const state = {strip, controls, previous, next, indicator};
    states.set(strip, state);
    return state;
  }

  function update(state) {
    const {strip, controls, previous, next, indicator} = state;
    const visible = phone.matches && strip.matches(selector) && strip.clientWidth > 0;
    if (controls.hidden === visible) controls.hidden = !visible;
    if (!visible) return;

    const max = Math.max(0, strip.scrollWidth - strip.clientWidth);
    const rtl = getComputedStyle(strip).direction === 'rtl';
    const position = Math.min(max, Math.max(0, rtl ? Math.abs(strip.scrollLeft) : strip.scrollLeft));
    const width = max > 1 ? Math.max(12, Math.min(100, strip.clientWidth / strip.scrollWidth * 100)) : 100;
    const progress = max > 1 ? position / max : 0;
    indicator.style.width = width + '%';
    indicator.style.left = (rtl ? 1 - progress : progress) * (100 - width) + '%';
    previous.disabled = max <= 1 || position <= 1;
    next.disabled = max <= 1 || position >= max - 1;
  }

  function refresh() {
    frame = 0;
    for (const [strip, state] of states) {
      if (!strip.isConnected) {
        strip.removeEventListener('scroll', queue);
        resizeObserver?.unobserve(strip);
        state.controls.remove();
        states.delete(strip);
      }
    }
    if (phone.matches) {
      document.querySelectorAll(selector).forEach(strip => {
        if (!states.has(strip)) create(strip);
      });
    }
    states.forEach(update);
  }

  function start() {
    new MutationObserver(queue).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['hidden']
    });
    phone.addEventListener('change', queue);
    window.addEventListener('resize', queue, {passive: true});
    document.addEventListener('shopify:section:load', queue);
    queue();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();



;

(() => {
  if (window.__hoGlobalMobilePromo20261028) return;
  window.__hoGlobalMobilePromo20261028 = true;
  const phone = matchMedia('(max-width: 749px)');
  let observedBar = null;
  let frame = 0;

  function measure() {
    frame = 0;
    if (!phone.matches || !observedBar?.isConnected) return;
    const container = observedBar.closest('.site-announcement') || observedBar;
    const height = Math.ceil(container.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--ho-mobile-promo-height', height + 'px');
  }
  function queueMeasure() {
    if (!frame) frame = requestAnimationFrame(measure);
  }
  const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(queueMeasure) : null;

  function update() {
    const bar = document.querySelector('.site-announcement .announcement-bar');
    const template = document.getElementById('ho-global-mobile-promo-template');
    if (!bar || !template) {
      if (observedBar) observer?.unobserve(observedBar.closest('.site-announcement') || observedBar);
      observedBar = null;
      document.body.classList.remove('ho-global-mobile-promo');
      document.documentElement.style.removeProperty('--ho-mobile-promo-height');
      return;
    }
    if (observedBar !== bar) {
      if (observedBar) observer?.unobserve(observedBar.closest('.site-announcement') || observedBar);
      observedBar = bar;
      observer?.observe(bar.closest('.site-announcement') || bar);
    }
    const current = bar.querySelector('.ho-mobile-promo');
    if (phone.matches) {
      if (!current) {
        const fragment = template.content.cloneNode(true);
        fragment.querySelector('.ho-mobile-promo').dataset.hoGlobalPromo = 'true';
        bar.append(fragment);
      }
      bar.classList.add('ho-has-mobile-promo');
      document.body.classList.add('ho-global-mobile-promo');
      queueMeasure();
    } else {
      if (current?.dataset.hoGlobalPromo) current.remove();
      bar.classList.remove('ho-has-mobile-promo');
      document.body.classList.remove('ho-global-mobile-promo');
      document.documentElement.style.removeProperty('--ho-mobile-promo-height');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, {once:true});
  else update();
  phone.addEventListener('change', update);
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('resize', queueMeasure, {passive:true});
})();


;

  (() => {
    if (window.__hoMobileHeaderSplit20261029) return;
    window.__hoMobileHeaderSplit20261029 = true;

    const phone = window.matchMedia('(max-width: 749px)');
    let record = null;
    let frame = 0;

    function restore() {
      if (!record?.moved) return false;
      for (const {node, anchor} of record.moves) {
        if (anchor.parentNode) anchor.parentNode.insertBefore(node, anchor);
        anchor.remove();
      }
      record.before.remove();
      record.after.remove();
      record.moves = [];
      record.moved = false;
      document.body.classList.remove('ho-mobile-header-split');
      return true;
    }

    function move(node, destination) {
      if (!node || !node.parentNode) return;
      const anchor = document.createComment('ho-mobile-header-original-position');
      node.parentNode.insertBefore(anchor, node);
      record.moves.push({node, anchor});
      destination.append(node);
    }

    function update() {
      frame = 0;
      const header = document.querySelector('[data-site-header]');
      let changed = false;
      if (record && record.header !== header) {
        changed = restore() || changed;
        record = null;
      }
      if (!header) {
        document.body.classList.remove('ho-mobile-header-split');
        return;
      }
      if (!record) record = {header, before: null, after: null, moves: [], moved: false};

      if (phone.matches && !record.moved) {
        record.before = document.createElement('div');
        record.before.className = 'ho-header-flow-before';
        record.after = document.createElement('div');
        record.after.className = 'ho-header-flow-after';
        header.parentNode.insertBefore(record.before, header);
        header.parentNode.insertBefore(record.after, header.nextSibling);

        move(header.querySelector(':scope > .ho-header-mobile-email'), record.before);
        move(header.querySelector('.site-header-main-content > .small-promo'), record.after);
        move(header.querySelector(':scope > .ho-header-delivery--mobile'), record.after);
        record.moved = true;
        document.body.classList.add('ho-mobile-header-split');
        changed = true;
      } else if (!phone.matches) {
        changed = restore() || changed;
      }

      // Notify the theme after its existing header nodes change size. This only
      // runs on a structural transition; the resulting resize does not loop.
      if (changed) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    }

    function queue() {
      if (!frame) frame = requestAnimationFrame(update);
    }

    phone.addEventListener('change', queue);
    window.addEventListener('resize', queue, {passive: true});
    document.addEventListener('shopify:section:load', queue);
    document.addEventListener('shopify:section:unload', event => {
      if (record && event.target instanceof Element && event.target.contains(record.header)) {
        restore();
        record = null;
      }
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue, {once: true});
    else queue();
  })();



(() => {
  if (window.__hoMobileStickyUtils20261031) return;
  window.__hoMobileStickyUtils20261031 = true;

  const mobile = window.matchMedia('(max-width: 859px)');
  const root = document.documentElement;
  let header = null;
  let frame = 0;
  let motionUntil = 0;
  let lastOffset = '';
  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(queue) : null;
  const headerObserver = new MutationObserver(queue);

  function measure() {
    frame = 0;
    const active = mobile.matches && header?.isConnected && document.querySelector('[data-sticky-utils]');
    document.body.classList.toggle('ho-mobile-utils-aligned', Boolean(active));
    if (!active) {
      root.style.removeProperty('--ho-visible-header-bottom');
      lastOffset = '';
      motionUntil = 0;
      return;
    }

    const style = getComputedStyle(header);
    const rect = header.getBoundingClientRect();
    const pinned = style.position === 'sticky' || style.position === 'fixed';
    const visible = pinned && style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0 && rect.top < window.innerHeight;
    const offset = visible ? Math.max(0, Math.round(rect.bottom * 100) / 100) : 0;
    const value = offset + 'px';
    if (value !== lastOffset) {
      root.style.setProperty('--ho-visible-header-bottom', value);
      lastOffset = value;
    }
    if (performance.now() < motionUntil) queue();
  }

  function queue() {
    if (!frame) frame = requestAnimationFrame(measure);
  }

  function trackMotion(event) {
    if (!(event.target instanceof Element)) return;
    const style = getComputedStyle(event.target);
    const seconds = value => value.split(',').map(part => {
      const number = parseFloat(part) || 0;
      return part.trim().endsWith('ms') ? number : number * 1000;
    });
    const duration = Math.max(0, ...seconds(style.transitionDuration));
    const delay = Math.max(0, ...seconds(style.transitionDelay));
    motionUntil = Math.max(motionUntil, performance.now() + Math.min(2000, duration + delay + 34));
    queue();
  }

  function refresh() {
    const current = document.querySelector('[data-site-header]');
    if (current !== header) {
      if (header) {
        resizeObserver?.unobserve(header);
        header.removeEventListener('transitionrun', trackMotion);
        header.removeEventListener('transitionstart', trackMotion);
        header.removeEventListener('transitionend', queue);
      }
      headerObserver.disconnect();
      header = current;
      if (header) {
        resizeObserver?.observe(header);
        headerObserver.observe(header, {attributes: true, subtree: true, attributeFilter: ['class', 'style', 'hidden']});
        header.addEventListener('transitionrun', trackMotion);
        header.addEventListener('transitionstart', trackMotion);
        header.addEventListener('transitionend', queue);
      }
    }
    queue();
  }

  function start() {
    const relevant = node => node instanceof Element && (node.matches('[data-site-header], [data-sticky-utils]') || node.querySelector('[data-site-header], [data-sticky-utils]'));
    const treeObserver = new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(relevant))) refresh();
    });
    treeObserver.observe(document.body, {childList: true, subtree: true});
    const bodyObserver = new MutationObserver(queue);
    bodyObserver.observe(document.body, {attributes: true, attributeFilter: ['class']});
    mobile.addEventListener('change', refresh);
    window.addEventListener('scroll', queue, {passive: true});
    window.addEventListener('resize', refresh, {passive: true});
    window.addEventListener('orientationchange', refresh, {passive: true});
    window.addEventListener('pageshow', refresh, {passive: true});
    window.visualViewport?.addEventListener('resize', queue, {passive: true});
    window.visualViewport?.addEventListener('scroll', queue, {passive: true});
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:unload', refresh);
    document.fonts?.ready.then(queue);
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
